import axios from 'axios';
import { env } from 'env';
import { ICustomStyles } from '../interfaces';
import { IWorldSettings } from '@interfaces/worlds';

export default class WorldsService {
  static getCustomStyles(
    domainName: string,
  ): Promise<{ customStyles: ICustomStyles | null }> {
    return axios
      .get(`${env.REACT_APP_API_URL}api/v2/worlds/styles`, {
        params: { domainName },
      })
      .then((res: any) => res.data);
  }

  /**
   * Resolves a hostname to its project settings.
   *
   * @param domainName - Host to resolve; the current `window.location.hostname`
   * outside local development.
   * @returns The project settings and the id of the project the domain maps to.
   * `worldId` is absent when the domain matches no project.
   */
  static getWorldSettings(
    domainName: string,
  ): Promise<{ settings: IWorldSettings | null; worldId?: string }> {
    return axios
      .get(`${env.REACT_APP_API_URL}api/v2/worlds/settings`, {
        params: { domainName },
      })
      .then((res: any) => res.data);
  }
}
